import cx from 'classnames';
import { appAssetsCdnUrl } from '~/constants/environment';
import optimizeImage from '~/utilities/optimizeImage';

type OwnProps = {
  className?: string;
};

export default function BrandImage({ className }: OwnProps) {
  return (
    <picture className={cx('overflow-hidden', className)}>
      <source
        media="(min-width: 1024px)"
        srcSet={optimizeImage(
          `${appAssetsCdnUrl}/images/home/brand-moment-desktop.jpg`,
          { format: 'auto', optimize: 'medium' }
        )}
      />
      <source
        media="(min-width: 768px)"
        srcSet={optimizeImage(
          `${appAssetsCdnUrl}/images/home/brand-moment-tablet.jpg`,
          { format: 'auto', quality: 85 }
        )}
      />
      <img
        src={optimizeImage(
          `${appAssetsCdnUrl}/images/home/brand-moment-mobile.jpg`,
          { format: 'auto', optimize: 'medium' }
        )}
        alt="Family in their driveway with a car"
        loading="lazy"
        className="w-full object-cover md:w-[1800px] md:max-w-[unset]"
      />
    </picture>
  );
}
